// extracted by mini-css-extract-plugin
module.exports = {"modal":"PopUp_modal__273dF","fullModal":"PopUp_fullModal__DMr5Y","modalHeader":"PopUp_modalHeader__3azrF"};